import { useState } from 'react';
import { useMe, useUpdateProfile } from '../../auth/authQueries';
import { Avatar } from '../../components/account/Avatar';
import { ProfileForm, type ProfileFormValues } from '../../components/account/ProfileForm';
import { Alert, Card, Skeleton, pushToast } from '../../components/ui';
import '../../components/account/account.css';

export default function ProfilePage() {
  const profile = useMe(true);
  const mutation = useUpdateProfile();
  const [errorMessage, setErrorMessage] = useState<string | null>(null);

  if (profile.isLoading) {
    return (
      <div className="stack">
        <h1>Hồ sơ cá nhân</h1>
        <Card>
          <Skeleton height="120px" />
        </Card>
      </div>
    );
  }

  if (profile.isError || !profile.data) {
    return (
      <div className="stack">
        <h1>Hồ sơ cá nhân</h1>
        <Alert tone="error">Không thể tải hồ sơ. Vui lòng thử lại.</Alert>
      </div>
    );
  }

  const data = profile.data;

  function handleSubmit(values: ProfileFormValues): void {
    setErrorMessage(null);
    mutation.mutate(values, {
      onSuccess: () => pushToast('Đã lưu hồ sơ.', 'success'),
      onError: () => setErrorMessage('Không thể lưu hồ sơ. Vui lòng thử lại.'),
    });
  }

  return (
    <div className="stack">
      <h1>Hồ sơ cá nhân</h1>

      <Card>
        <div className="account-head">
          <Avatar displayName={data.displayName} pictureUrl={data.pictureUrl} />
          <div>
            <strong style={{ fontSize: '1.1rem' }}>{data.displayName ?? 'Người dùng'}</strong>
            <div className="muted">
              {data.email ?? 'Chưa có email'}
              {data.email ? (
                <span
                  className={`badge ${data.emailVerified ? 'badge--active' : 'badge--warn'}`}
                  style={{ marginLeft: 8 }}
                >
                  {data.emailVerified ? 'Đã xác minh' : 'Chưa xác minh'}
                </span>
              ) : null}
            </div>
          </div>
        </div>
      </Card>

      <Card>
        <h2>Chỉnh sửa thông tin</h2>
        <ProfileForm
          defaultValues={{
            displayName: data.displayName ?? '',
            accountRole: data.accountRole ?? 'student',
          }}
          onSubmit={handleSubmit}
          submitting={mutation.isPending}
          errorMessage={errorMessage}
        />
        <p className="muted" style={{ fontSize: '0.85rem' }}>
          Để thay đổi email, vui lòng dùng quy trình riêng (chưa hỗ trợ tại đây).
        </p>
      </Card>
    </div>
  );
}
